<template>
  <div class="bl-tab-nav">
    <span class="bl-tab-nav__icon">
      <!-- @slot Slot to provide a tab nav icon -->
      <slot name="iconTabNav"></slot>
    </span>
    <bl-text-av v-if="!$slots.iconTabNav" variation="body-14" weight="bold" :tag="titleTag" color="disabled" :ellipsis="2">
      <slot></slot>
      <template v-if="!$slots.default">
        {{ title }}
      </template>
    </bl-text-av>
    <bl-badge-av v-if="notification > 0" :count="notification" size="medium" class="bl-tab-nav__notification" />
  </div>
</template>

<script>
/**
 * Modified BlTabNavMv from bazaar to support customized tag on title
 */
import {BlTextAv, BlBadgeAv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'BlTabNavMv',
  components: {
    BlBadgeAv,
    BlTextAv,
  },
  props: {
    /**
     * Name is a title of tab
     */
    title: {
      type: String,
      default: '',
    },
    /**
     * Notification is badge notification on tab
     */
    notification: {
      type: Number,
      default: 0,
    },
    titleTag: {
      type: String,
      default: 'span',
    },
  },
};
</script>
